export const INITIAL_FIELD_RULES = {
  dcsnItemCd: {
    rules: [
      {
        required: true,
        message: "검수등급은 필수조건입니다.",
      },
    ],
  },
};
